export const toggleDisabledDays = (selectedDays, daysToToggle) => {
  const result = daysToToggle.map((day) => ({
    ...day,
    disabled: selectedDays.some((selectedDay) =>
      selectedDay.some((selected) => selected.value === day.value),
    ),
  }));
  return result;
};
